import { css as _css } from "@emotion/core";

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

import React from "react";
import PropTypes from "prop-types";
import useTheme from "../hooks/useTheme";
import { TextStyleProvider } from "../hooks/useTextStyle";
import useBackground, { BackgroundProvider } from "../hooks/useBackground";
import { responsiveMarginType, responsivePaddingType, responsiveWidthType, responsiveHeightType, responsivePropType } from "../hooks/useResponsiveProp";
import useResponsivePropsCSS from "../hooks/useResponsivePropsCSS";
import { responsiveMargin, responsivePadding, responsiveSize, responsiveTextAlign, responsiveOverflow, responsiveHasBreakpointWidth } from "../utils/css";
import { getResponsivePropMap, mergeResponsivePropMaps } from "../utils/component";
import { TEXT_STYLES, TEXT_ALIGNS } from "../utils/constants";
import { jsx as ___EmotionJSX } from "@emotion/core";
var BACKGROUNDS = ["transparent", "white", "grey.t03", "grey.t05", "grey.t07", "secondary.lightBlue.t15", "secondary.lightBlue.t25", "primary.blue.t100"];
var borderColorMap = {
  transparent: "grey.t16",
  white: "grey.t16",
  "grey.t03": "grey.t10",
  "grey.t05": "grey.t16",
  "grey.t07": "grey.t16",
  "secondary.lightBlue.t15": "secondary.lightBlue.t60",
  "secondary.lightBlue.t25": "secondary.lightBlue.t80",
  "primary.blue.t100": "white"
};
var BOX_SHADOWS = ["header"];
var DEFAULT_PROPS = {
  bg: "transparent",
  flexGrow: false,
  hasBorder: false,
  hasBreakpointWidth: false,
  hide: false
};
Container.BACKGROUNDS = BACKGROUNDS;
Container.BOX_SHADOWS = BOX_SHADOWS;
Container.DEFAULT_PROPS = DEFAULT_PROPS;

function Container(_props) {
  var props = _objectSpread(_objectSpread({}, DEFAULT_PROPS), _props);

  var boxShadow = props.boxShadow,
      textStyle = props.textStyle,
      children = props.children,
      testId = props.testId;
  var theme = useTheme();

  var _useBackground = useBackground(),
      inheritedBgMap = _useBackground.bgMap;

  var myBgMap = getResponsivePropMap(_props, DEFAULT_PROPS, "bg", theme);
  var mergedResponsiveBgMap = mergeResponsivePropMaps(inheritedBgMap, myBgMap, theme);
  var responsiveCSS = useResponsivePropsCSS(props, DEFAULT_PROPS, {
    margin: responsiveMargin,
    padding: responsivePadding,
    width: responsiveSize("width"),
    height: responsiveSize("height"),
    textAlign: responsiveTextAlign,
    overflow: responsiveOverflow,
    hasBreakpointWidth: responsiveHasBreakpointWidth,
    bg: function bg(_ref, theme, bp) {
      var hasBorder = _ref.hasBorder;
      var bg = mergedResponsiveBgMap[bp] === "transparent" ? "transparent" : mergedResponsiveBgMap[bp];
      var borderColor = hasBorder ? borderColorMap[bg] : null;
      return _objectSpread({
        backgroundColor: bg === "transparent" ? "transparent" : theme.getColor(bg)
      }, borderColor && {
        border: "".concat(theme.borderWidths[0], " solid ").concat(theme.getColor(borderColor))
      });
    },
    flexGrow: function flexGrow(_ref2) {
      var _flexGrow = _ref2.flexGrow;

      if (_flexGrow) {
        return {
          flexGrow: 1
        };
      }

      return {};
    },
    hide: function hide(_ref3) {
      var _hide = _ref3.hide;
      return _hide ? {
        display: "none"
      } : {};
    }
  });

  var container = ___EmotionJSX("div", {
    css: /*#__PURE__*/_css(_objectSpread(_objectSpread({
      boxSizing: "border-box"
    }, responsiveCSS), boxShadow === "header" && {
      "::after": {
        content: "''",
        display: "block",
        height: theme.borderWidths[1],
        boxShadow: theme.shadows.header
      }
    }), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"),
    "data-testid": testId
  }, children);

  if (textStyle) {
    container = ___EmotionJSX(TextStyleProvider, {
      value: textStyle
    }, container);
  }

  return ___EmotionJSX(BackgroundProvider, {
    value: mergedResponsiveBgMap
  }, container);
}

Container.propTypes = _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({
  boxShadow: PropTypes.oneOf(BOX_SHADOWS)
}, responsiveMarginType), responsivePaddingType), responsiveWidthType), responsiveHeightType), responsivePropType("bg", PropTypes.oneOf(BACKGROUNDS))), responsivePropType("flexGrow", PropTypes.bool)), responsivePropType("hasBorder", PropTypes.bool)), responsivePropType("textStyle", PropTypes.oneOf(TEXT_STYLES))), responsivePropType("textAlign", PropTypes.oneOf(TEXT_ALIGNS))), responsivePropType("overflow", PropTypes.string)), responsivePropType("hasBreakpointWidth", PropTypes.bool)), responsivePropType("hide", PropTypes.bool)), {}, {
  children: PropTypes.node,
  testId: PropTypes.string
});
export default Container;